module.exports = __webpack_public_path__ + "img/pic_india_05.25479e79.jpg";